import React from 'react';
import { PageSettings } from '../ast/document.types';

interface PageSheetProps {
  pageNumber: number;
  totalPages: number;
  settings: PageSettings;
  children: React.ReactNode;
}

export const PageSheet: React.FC<PageSheetProps> = ({
  pageNumber,
  totalPages,
  settings,
  children,
}) => {
  // Page width/min-height based on paper standard
  const getPageDimensions = () => {
    switch (settings.paperSize) {
      case 'Letter':
        return { maxWidth: '720px', minHeight: '932px' };
      case 'Legal':
        return { maxWidth: '720px', minHeight: '1186px' };
      case 'A4':
      default:
        return { maxWidth: '680px', minHeight: '960px' };
    }
  };

  const { maxWidth, minHeight } = getPageDimensions();

  return (
    <div
      className="paper-sheet doc-rendered-page"
      data-page-number={pageNumber}
      style={{
        maxWidth,
        minHeight,
        paddingTop: `${settings.margins.topMm}mm`,
        paddingBottom: `${settings.margins.bottomMm}mm`,
        paddingLeft: `${settings.margins.leftMm}mm`,
        paddingRight: `${settings.margins.rightMm}mm`,
        fontFamily: settings.defaultFontFamily,
        fontSize: `${settings.defaultFontSizePt}pt`,
        lineHeight: settings.defaultLineSpacing,
        backgroundColor: '#ffffff',
        color: '#111827',
        boxShadow: 'var(--shadow-paper)',
        marginBottom: '28px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'relative',
        boxSizing: 'border-box',
      }}
    >
      {/* Running Header */}
      {settings.headerText && (
        <div
          style={{
            fontSize: '9pt',
            color: '#9ca3af',
            borderBottom: '1px solid #f3f4f6',
            paddingBottom: '4px',
            marginBottom: '16px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <span>{settings.headerText}</span>
          <span>{settings.paperSize}</span>
        </div>
      )}

      {/* Main Page Flow Content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </div>

      {/* Running Footer & Page Number */}
      <div
        style={{
          marginTop: 'auto',
          paddingTop: '12px',
          borderTop: '1px solid #f3f4f6',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '9pt',
          color: '#9ca3af',
          userSelect: 'none',
        }}
      >
        <span>{settings.footerText || ''}</span>
        {settings.showPageNumbers && (
          <span>
            Page {pageNumber} of {totalPages}
          </span>
        )}
      </div>
    </div>
  );
};
